export default "__VITE_ASSET__c08c6c3e__"